var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge"},[_vm._v("\n  ("+_vm._s(_vm.total)+" record"+_vm._s(_vm.total == 1 ? '' : 's')+")\n")])}
var staticRenderFns = []

export { render, staticRenderFns }